import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import Logo from "@/components/Logo";
import Icon from "@/components/Icon";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [totp, setTotp] = useState("");
  const [need2fa, setNeed2fa] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      const payload = { email, password };
      if (need2fa) payload.totp_code = totp;
      const { data } = await api.post("/admin/login", payload);
      if (data.totp_required) { setNeed2fa(true); toast.info("Two-factor authentication required"); }
      else { toast.success("Welcome back"); nav("/admin", { replace: true }); }
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-background p-6" data-testid="admin-login-page">
      <div className="w-full max-w-sm fade-up">
        <div className="flex items-center gap-2 justify-center mb-6"><Logo /><span className="text-[10px] font-bold uppercase tracking-wider bg-primary/15 text-primary px-1.5 py-0.5 rounded">Admin</span></div>
        <div className="rounded-2xl border border-border bg-card p-6 shadow-sm">
          <div className="flex items-center gap-2 mb-1"><Icon name="ShieldCheck" className="h-5 w-5 text-primary" /><h1 className="text-xl font-display font-extrabold">Admin sign in</h1></div>
          <p className="text-sm text-muted-foreground mt-1 mb-5">Restricted area. Authorized administrators only.</p>
          <form onSubmit={submit} className="space-y-3">
            <input data-testid="admin-login-email" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} disabled={need2fa} className="w-full rounded-xl border border-input bg-background px-3.5 py-2.5 text-sm outline-none focus:ring-2 focus:ring-primary/40 disabled:opacity-60" />
            <input data-testid="admin-login-password" type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} disabled={need2fa} className="w-full rounded-xl border border-input bg-background px-3.5 py-2.5 text-sm outline-none focus:ring-2 focus:ring-primary/40 disabled:opacity-60" />
            {need2fa && <input data-testid="admin-login-totp" inputMode="numeric" required placeholder="6-digit authentication code" value={totp} onChange={(e) => setTotp(e.target.value)} className="w-full rounded-xl border border-input bg-background px-3.5 py-2.5 text-sm outline-none focus:ring-2 focus:ring-primary/40 tracking-[0.3em]" />}
            <button data-testid="admin-login-submit" disabled={loading} className="w-full rounded-xl bg-primary text-primary-foreground py-2.5 text-sm font-bold hover:opacity-90 disabled:opacity-60">{loading ? "Please wait..." : need2fa ? "Verify code" : "Sign in"}</button>
          </form>
          <button onClick={() => nav("/")} className="mt-4 text-xs text-muted-foreground hover:text-foreground w-full text-center">← Back to website</button>
        </div>
      </div>
    </div>
  );
}
